module.exports = __webpack_public_path__ + "static/media/AA Smartfuel Logo.cda35692.jpg";